export const getSender=(loggedUser,users)=>{
console.log("getSender users",users)
if(users.length>1){
  return users[0]._id===loggedUser.user._id?users[1].name :users[0].name;
}

  }
  
export const getSenderPicture=(loggedUser,users)=>{
  if(users.length>1){
     return users[0]._id ===loggedUser.user._id?users[1].picture:users[0].picture;
  }
}
  export const  getSenderFull=(loggedUser,users)=>{
    if(users.length>1){
    return users[0]._id ===loggedUser.user._id?users[1]:users[0];
    }
}





//NOTE:m=>current sender, i=>index
export const isSameSenderMargin = (messages, m, i, userId) => {
    // console.log(i === messages.length - 1);
  
    if (
      i < messages.length - 1 &&
      messages[i + 1].sender._id === m.sender._id &&
      messages[i].sender._id !== userId
    )
      return 33;
    else if (
      (i < messages.length - 1 &&
        messages[i + 1].sender._id !== m.sender._id &&
        messages[i].sender._id !== userId) ||
      (i === messages.length - 1 && messages[i].sender._id !== userId)
    )
      return 0;
    else return "auto";
  };
  
  export const isSameSender = (messages, m, i, userId) => { 

    return (
      i < messages.length - 1 &&
      (messages[i + 1].sender._id !== m.sender._id ||
        messages[i + 1].sender._id === undefined) &&
      messages[i].sender._id !== userId //check if the sender is not the logged user, then only show avatar(pic)
    );
  };
  
  export const isLastMessage = (messages, i, userId) => {
    return (
      i === messages.length - 1 &&
      messages[messages.length - 1].sender._id !== userId &&
      messages[messages.length - 1].sender._id
    );
  };
  
  export const isSameUser = (messages, m, i) => {
    return i > 0 && messages[i - 1].sender._id === m.sender._id;
  };
  